import React from "react";
import css from "./FolderStructureBlog.module.css";
import {HierarchyView,BlogView,SectionView,TextView, NoticeView} from "Components";


export default function FolderStructureBlog(){
    return (
        <BlogView className={css.folderstructureblog}>
            <SectionView 
                title="Folder Structure"
                text="A vritra-themed project should look like this:"
            >
                <HierarchyView hierarchy={statics.structure}/>
                <TextView text={`
                    The project requires these <span>specific</span> filenames to exist 
                    for successful building:
                `}/>
                <ul className={css.requiredentries}>
                    {statics.requiredEntries.map(entry=>(
                        <li key={entry.path}>
                            <span>{entry.path}</span>
                            <span>{entry.description}</span>
                        </li>
                    ))}
                </ul>
                <NoticeView>
                    Subdirectories should be created within the src directory. 
                    Only files located within src undergo webpack processing. 
                    @It is imperative to place JS and CSS files within src 
                    in order for webpack to recognize them.
                    @You no longer have to deal with the www folder, as all of its content 
                    will be handled by webpack.
                </NoticeView>
            </SectionView>
        </BlogView>
    )
}

const statics={
    requiredEntries:[
        {
            path:"src/WebViews/index.js",
            description:"is a file to target all webviews at once",
        },
        {
            path:"src/WebViews/index.css",
            description:"is a file to style all webviews at once",
        },
        {
            path:"src/WebViews/WebViews.js",
            description:"is the webview-registration file",
        }
    ],
    structure:[
        ...["node_modules","platforms","plugins"].map(name=>({name,children:[]})),
        {
            name:"src",
            children:[
                ...["Assets","Components","Resources","Screens","Store"].map(name=>({name,children:[]})),
                {
                    name:"WebViews",
                    children:[
                        {name:"MainView",children:[]},
                        ...["index.css","index.js","WebViews.js"].map(name=>({name})),
                    ],
                },
            ],
        },
        ...[
            ".gitignore","config.xml","jsconfig.json",
            "package-lock.json","package.json",
        ].map(name=>({name})),
    ],
}
